import React from "react";
import CircleTooltip from "./CircleTooltip"; // Assuming CircleTooltip is already a component
import getDisplayVersion from "../../../utils/getDisplayVersion";
import { VersionPickerProps } from "../../../types/menu";

const VersionPicker: React.FC<VersionPickerProps> = ({
  currentPath,
  version,
  categoryVersions,
  latestVersion,
  changeSelectedVersion,
  dispatch,
}) => {
  return (
    <div className="flex flex-row h-10 justify-between md:space-x-4 mb-4 mt-4">
      {currentPath && currentPath !== "release_notes" && (
        <>
          {/* border-r-8 border-transparent is a nice hack to force the down arrow inward*/}
          <select
            className="w-64 h-9 ml-8 mr-4 p-0.5 px-3 border-r-8 border-transparent text-sm bg-medium-dark-grey text-soft-blue-grey rounded-3xl focus:outline-none"
            value={version}
            onChange={(event) => {
              changeSelectedVersion(event.target.value);
              dispatch({ type: "closeSidebar" });
            }}
          >
            {categoryVersions.map((v) => (
              <option key={v} value={v}>
                {getDisplayVersion(v, latestVersion)}
              </option>
            ))}
          </select>
          <div className="flex items-center align-middle">
            <CircleTooltip
              text="Click here to view the latest versions on our documentation site"
              link="https://docs.dominodatalab.com/"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default VersionPicker;
